import React, { useEffect, useState } from 'react';
import FilterDropdown from '../Filter/components/FilterDropdown';
import { translate } from '../../services/translate';
import { armoryService } from '../../services/central-api/armory';


interface Props {
    value: number[];
    setValue: React.Dispatch<React.SetStateAction<number[]>>;
    zIndex: number;
    actingBodyId: number;
    required: boolean;
    labelFontSize?: number;
    disabled?: boolean;
    userId: number;
}

function AssistantsArmourerDropdown({ value, setValue, zIndex, actingBodyId, required, userId, labelFontSize = 16, disabled = false }: Props) {
    const [selectableUsers, setSelectableUsers] = useState<{ label: string; value: number; }[]>([]);

    async function getUsers(actingBodyId: number, userId: number) {
        try {
            const users = await armoryService.getArmourers({ actingBodyId });
            setSelectableUsers([
                ...users.filter(user => user.id != userId).map((user) => {
                    return {
                        value: user.id,
                        label: `${user.warName ? user.warName : user.name} - RF: ${user.registry}`
                    };
                })
            ]);
        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        if (actingBodyId !== 0 && userId !== 0) {
            getUsers(actingBodyId, userId);
        }
    }, [actingBodyId, userId]);

    return (
        <FilterDropdown
            label={translate('assistantsArmourer')}
            items={selectableUsers}
            multiple={true}
            mode='BADGE'
            setValue={setValue}
            value={value}
            zIndex={zIndex}
            required={required}
            labelFontSize={labelFontSize}
            disabled={disabled}
        />
    );
}

export default AssistantsArmourerDropdown;
